import { useIsUserAuthenticated } from "@/application/providers/user/model/user-context";
import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { SIGN_IN_PATH } from "@/modules/auth/pages/sign-in";

export function LoginRedirect({ children }: { children: ReactNode }) {
  const isUserAuthenticated = useIsUserAuthenticated();
  const location = useLocation();

  if (!isUserAuthenticated) {
    return <Navigate to={SIGN_IN_PATH} state={{ from: location }} replace />;
  }

  return children;
}
